import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export default function Footer() {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width: 600px)');

    return (
        <Box
            component="footer"
            sx={{
                width: '100%',
                padding: isMobile ? '12px 16px' : '16px 32px',
                backgroundColor: theme.palette.background.paper,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '8px' : '16px',
                marginTop: 'auto',
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.text.secondary,
                    fontSize: isMobile ? '12px' : '14px',
                    fontWeight: 500,
                    textAlign: isMobile ? 'center' : 'left'
                }}
            >
                Sistema de Gestión y Mantenimiento - CETEMIN
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.text.secondary,
                    fontSize: isMobile ? '11px' : '13px',
                    textAlign: isMobile ? 'center' : 'right'
                }}
            >
                Desarrollado por Equipo TIC - 2025 - v2
            </Typography>
        </Box>
    );
}
